import sideSearchForm from '../../templates/sidebar-search-form.js';
import AlgoliaAutocomplete from '../services/algolia-autocomplete.js';

export default class AlgoliaSearch {
  constructor() {
    this._initAlgoliaIndex();
    this.searchSidebarForm = $('.site-sidebar-search');
    this._reInitSidebarSearch();
  }

  listenEvents() {
    this._listenInputEventsForAlgoliaSearch();
  }
  _listenInputEventsForAlgoliaSearch() {
    if (typeof algoliasearch !== 'function') return;
    this._initAlgoliaSearch();
  }

  _initAlgoliaLibraries() {
    const { autocomplete } = window['@algolia/autocomplete-js'];
    const emptyContainer = document.createElement('div');
    autocomplete({
      container: emptyContainer
    });
  }

  _initAlgoliaIndex() {
    const algoliaClient = algoliasearch(
      algolia_application_id,
      algolia_search_only_api_key
    );
    this.algoliaIndex = algoliaClient.initIndex(publication_id);
    this.QuerySuggestionindex = algoliaClient.initIndex(`QS-index`);
    this.resultsInPage = 10;
  }

  _reInitSidebarSearch() {
    const $sideBar = $('.site-sidebar');
    const $sideBarInput = $('.site-sidebar-search input');
    const $sideBarSearch = $('.site-sidebar-search');
    this.searchSidebarForm.remove();
    this.searchSidebarForm.prependTo($sideBar);
    $sideBarSearch.prepend('<span class="icon-search"></span>');
    $sideBarSearch.append('<span class="icon-delete"></span>');
    $sideBarInput.attr('id', 'side-search-bar');
    $sideBarInput.attr('placeholder', 'Search Rapyd Docs');
    $sideBarInput.attr('maxlength', 30);
    $sideBar.prepend(sideSearchForm);
  }

  _sortHits(hits) {
    this.categorizedResults = {};
    Object.keys(this.categories).forEach(
      categoryKey => (this.categorizedResults[categoryKey] = [])
    );
    hits.forEach(hit => {
      Object.keys(this.categorizedResults).forEach(categoryKey => {
        if (hit.category?.includes(this.categories[categoryKey].name)) {
          this.categorizedResults[categoryKey].push(hit);
        }
      });
      this.categorizedResults.ALL.push(hit);
    });
  }

  _assignIconToHit(category) {
    switch (category) {
      case 'REF':
        this.icon = 'icon-developers';
        break;
      case 'GUIDE':
        this.icon = 'icon-book';
        break;
      case 'CP':
        this.icon = 'icon-plugin';
        break;
      default:
        this.icon = 'icon-doc';
        break;
    }
  }

  _disableButton(button) {
    button.classList.add('disabled');
    button.setAttribute('disabled', true);
  }

  _openRecentAndPopularSearchesModal(popularSearchResults) {
    const recentSearchesScript = AlgoliaAutocomplete.createScriptsAndAppend();
    const searchThis = this;
    const $searchResults = $('.search-results');
    const recentSearches =
      JSON.parse(localStorage.getItem('last_searches')) || [];
    recentSearchesScript.addEventListener('load', function() {
      searchThis._initAlgoliaLibraries();
    });
    $searchResults.empty();
    if (recentSearches.length > 0) {
      $searchResults.append(
        `<span class="search-results-headline">RECENT</span>`
      );
      recentSearches.forEach((hit, index) => {
        if (searchThis.isSideSearch && index > 1) return;
        this._appendResultForRecent($searchResults, hit);
      });
      $searchResults.append(
        `<hr class="search-results-separating-line recent">`
      );
    }
    $searchResults.append(
      `<span class="search-results-headline">POPULAR SEARCHES</span>`
    );
    if (popularSearchResults.length > 0)
      popularSearchResults.forEach((search, index) => {
        if (searchThis.isSideSearch && index > 1) return;
        if (index > 3) return;
        this._appendResultForPopular($searchResults, search);
      });
    this._openSearchDropdown();
  }

  _enableButton(button) {
    button.classList.remove('disabled');
    button.removeAttribute('disabled');
  }

  _handlePageButtonsStatus() {
    const paginationNumbers = document.body.querySelectorAll(
      '.pagination-number'
    );
    const prev = document.body.querySelector('.pagination-button-prev');
    const next = document.body.querySelector('.pagination-button-next');
    const pageCount = paginationNumbers[paginationNumbers.length - 1].innerHTML;
    if (this.currentPage === 1) {
      this._disableButton(prev);
    } else {
      this._enableButton(prev);
    }
    if (Number(pageCount) === this.currentPage) {
      this._disableButton(next);
    } else {
      this._enableButton(next);
    }
  }

  _setPageToPrev() {
    this.currentPage = this.currentPage - 1;
    this._allResultModalDisplayPagination();
  }
  _setPageToNext() {
    this.currentPage = this.currentPage + 1;
    this._allResultModalDisplayPagination();
  }

  _getNextResultsPagination() {
    const startIndex = (this.currentPage - 1) * this.resultsInPage;
    const endIndex = startIndex + this.resultsInPage;
    this.allReaultsDisplayData = this.categorizedResults[
      this.pickedCategory
    ].slice(startIndex, endIndex);
  }

  _getNextResultsInfiniteScroll() {
    const $searchResults = $('.search-results-all');
    this.currentPage = this.currentPage + 1;
    const startIndex = (this.currentPage - 1) * this.resultsInPage;
    const endIndex = startIndex + this.resultsInPage;
    const currentDataToDisplay = this.categorizedResults[
      this.pickedCategory
    ].slice(startIndex, endIndex);
    currentDataToDisplay.forEach(hit => {
      this._assignIconToHit(this.pickedCategory);
      this._appendResultForAllResults($searchResults, hit);
      $searchResults.append(`<div class="result-separator"/>`);
    });
  }

  _getInitialResultsInfiniteScroll() {
    const $searchResults = $('.search-results-all');
    const currentDataToDisplay = this.categorizedResults[
      this.pickedCategory
    ].slice(0, this.resultsInPage);
    currentDataToDisplay.forEach(hit => {
      this._assignIconToHit(this.pickedCategory);
      this._appendResultForAllResults($searchResults, hit);
      $searchResults.append(`<div class="result-separator"/>`);
    });
  }

  _handleActivePageNumber() {
    const paginationNumbers = document.body.querySelectorAll(
      '.pagination-number'
    );
    paginationNumbers.forEach(button => {
      button.classList.remove('active');
      const pageIndex = Number(button.getAttribute('page-index'));
      if (pageIndex === this.currentPage) {
        button.classList.add('active');
      }
    });
    this._getNextResultsPagination();
  }

  _appendPageNumber(index) {
    const $paginationNumbers = $('.pagination-numbers');
    const pageNumber = document.createElement('button');
    const searchThis = this;
    pageNumber.className = 'pagination-number';
    pageNumber.innerHTML = index;
    pageNumber.setAttribute('page-index', index);
    pageNumber.setAttribute('aria-label', 'Page ' + index);

    pageNumber.addEventListener('click', function(event) {
      event.preventDefault();
      searchThis.currentPage = index;
      searchThis._allResultModalDisplayPagination();
    });
    $paginationNumbers[0].appendChild(pageNumber);
  }

  _appendDotsForPagination() {
    const $paginationNumbers = $('.pagination-numbers');
    const pageDots = document.createElement('span');
    pageDots.innerHTML = '...';
    pageDots.className = 'pagination-dots';
    $paginationNumbers[0].appendChild(pageDots);
  }

  _createPagination(numberOfHits, nbPages) {
    if (nbPages <= this.resultsInPage) {
      for (let i = 1; i <= nbPages; i++) {
        this._appendPageNumber(i);
      }
    } else {
      this._appendPageNumber(1);
      if (this.currentPage > 3) {
        this._appendDotsForPagination();
      }
      if (this.currentPage === this.resultsInPage) {
        this._appendPageNumber(this.currentPage - 2);
      }
      if (this.currentPage > 2) {
        this._appendPageNumber(this.currentPage - 1);
      }
      if (this.currentPage !== 1 && this.currentPage !== nbPages) {
        this._appendPageNumber(this.currentPage);
      }
      if (this.currentPage < nbPages - 1) {
        this._appendPageNumber(this.currentPage + 1);
      }
      if (this.currentPage === 1) {
        this._appendPageNumber(this.currentPage + 2);
      }
      if (this.currentPage < nbPages - 2) {
        this._appendDotsForPagination();
      }
      this._appendPageNumber(nbPages);
    }
  }

  _createBreadcrumbs(breadcrumbs) {
    const breadcrumbsArr = breadcrumbs.split('/');
    const breadcrumbsItem = document.createElement('div');
    breadcrumbsItem.className = 'breadcrumbs-container';
    breadcrumbsArr.map((item, index) => {
      const breadcrumb = document.createElement('span');
      breadcrumb.innerText = item || '';
      breadcrumb.className = 'breadcrumb-text';
      if (index === breadcrumbsArr.length - 1) {
        breadcrumb.classList.add('mark');
      }
      breadcrumbsItem.appendChild(breadcrumb);
      if (index < breadcrumbsArr.length - 1) {
        const breadcrumbIcon = document.createElement('div');
        breadcrumbIcon.className = 'icon icon-chevron_right';
        breadcrumbsItem.appendChild(breadcrumbIcon);
      }
    });
    return breadcrumbsItem.innerHTML;
  }

  _addResultsToRecentSearches(item) {
    if (!localStorage.getItem('last_searches')) {
      localStorage.setItem('last_searches', JSON.stringify([]));
    }
    const localStorageSearches = JSON.parse(
      localStorage.getItem('last_searches')
    );
    const unique = localStorageSearches.filter(({ url }) => item.url !== url);
    unique.unshift(item);
    const sliced = unique.slice(0, 4);
    localStorage.setItem('last_searches', JSON.stringify(sliced));
  }

  _appendResult(appendTo, hit) {
    const bodyIsJSON = ['{', '}'].some(el =>
      hit._highlightResult.body.value.includes(el)
    );
    appendTo.append(`
                    <a class="search-result-container" href=${
                      hit.url
                    } target="_self">
                        <div  class="search-result-data">
                          <div class="search-result-icon icon ${this.icon}"/>
                          <div>
                              <div class="search-result-title">
                                  ${hit._highlightResult.title.value ||
                                    (bodyIsJSON ? 'Code Sample' : '')}
                              </div>
                              <div class="search-result-breadcrumbs">${this._createBreadcrumbs(
                                hit.breadcrumbs
                              )}</div>
                            </div>
                        </div>
                      </a>
                   `);
  }

  _appendResultForAllResults(appendTo, hit) {
    const bodyIsJSON = ['{', '}'].some(el => hit.body.includes(el));
    appendTo.append(`
                      <a class="search-result-container all" href=${
                        hit.url
                      } target="_self">
                        <div  class="search-result-data all">
                          <div class="all-results-title-container">
                            <div class="search-result-icon icon ${
                              this.icon
                            } all"/>
                             <div class="search-result-title all">
                                 ${hit._highlightResult.title.value ||
                                   (bodyIsJSON ? 'Code Sample' : '')}
                             </div>
                           </div>
                           ${
                             this.isSideSearch
                               ? ''
                               : `<div class="search-result-body all"> ${
                                   bodyIsJSON
                                     ? hit.url
                                     : hit._highlightResult.body.value
                                 }</div>`
                           }
                           <div class="search-result-breadcrumbs all">${this._createBreadcrumbs(
                             hit.breadcrumbs
                           )}</div>
                         </div>
                      </a>
                   `);
  }

  _appendResultForRecent(appendTo, hit) {
    const iconClasses = Object.values(hit.icon).reduce(
      (a, currentValue) => a + ' ' + currentValue,
      ''
    );
    appendTo.append(`
                     <a class="search-result-container recent" href="${hit.url}" target="_self">
                       <div class="search-result-data recent">
                            <div class="${iconClasses} recent"/>
                            <div class="title-breadcrumbs-container recent">
                                <div class="search-result-title recent">
                                    ${hit.title}
                                </div>
                                <div class="search-result-breadcrumbs recent">
                                    ${hit.breadcrumbs}
                                </div>
                            </div>
                         </div>
                       </a>
                   `);
  }

  _appendResultForPopular(appendTo, search) {
    appendTo.append(`
                       <div class="search-result-data popular">
                           <span class="search-result-icon icon icon-timer" /> 
                           <div class="search-result-title popular">
                               ${search.query}
                           </div>
                       </div>
                   `);
  }

  _initPickedCategory() {
    let found = false;
    Object.keys(this.categorizedResults)
      .reverse()
      .forEach(key => {
        if (this.categorizedResults[key].length > 0) {
          this.pickedCategory = key;
          found = true;
        }
      });
    if (!found) this.pickedCategory = '';
  }

  _displayAllResultPagination() {
    const $searchResults = $('.search-results-all');
    $searchResults.empty();
    this._handleActiveCategory();
    this._allResultModalFooterPagination();
    if (this.allReaultsDisplayData.length > 0) {
      this.allReaultsDisplayData.forEach((hit, hitIndex) => {
        this._assignIconToHit(this.pickedCategory);
        this._appendResultForAllResults($searchResults, hit);
        if (hitIndex < this.allReaultsDisplayData.length - 1) {
          $searchResults.append(`<div class="result-separator"/>`);
        }
      });
    }
  }

  _displayAllResultInfiniteScroll() {
    const $searchResults = $('.search-results-all');
    $searchResults.empty();
    this._handleActiveCategory();
    this._getInitialResultsInfiniteScroll();
    this._allResultModalFooterInfiniteScroll();
  }

  _allResultModalFooterPagination() {
    const $pagination = $('.pagination-container');
    const searchThis = this;
    const nbHits = this.categorizedResults[this.pickedCategory].length;
    const nbPages = Math.ceil(nbHits / this.resultsInPage);
    if (nbPages > 1) {
      $pagination.append(`
        <div class="pagination-items">
          <button class="pagination-button-prev" id="prev-button" aria-label="Previous page" title="Previous page">
             <span class="icon icon-chevron_left" /> 
          </button>
          <div class="pagination-numbers">
          </div>
          <button class="pagination-button-next" id="next-button" aria-label="Next page" title="Next page">
            <span class="icon icon-chevron_right" /> 
          </button>
        </div>

    `);
      this._createPagination(nbHits, nbPages);
      const prev = document.body.querySelector('.pagination-button-prev');
      const next = document.body.querySelector('.pagination-button-next');
      prev.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        searchThis._setPageToPrev();
      });
      next.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        searchThis._setPageToNext();
      });
      this._handleActivePageNumber();
      this._handlePageButtonsStatus();
    } else {
      this.allReaultsDisplayData = this.categorizedResults[this.pickedCategory];
    }
  }

  _allResultModalFooterInfiniteScroll() {
    const searchThis = this;
    const nbHits = this.categorizedResults[this.pickedCategory].length;
    const nbPages = Math.ceil(nbHits / this.resultsInPage);
    if (nbPages > 1) {
      $('.search-results-all').scroll(function() {
        if (
          Math.ceil($(this).scrollTop() + $(this).innerHeight()) >=
          $(this)[0].scrollHeight
        ) {
          searchThis._getNextResultsInfiniteScroll();
        }
      });
    } else {
      this.allReaultsDisplayData = this.categorizedResults[this.pickedCategory];
    }
  }

  _handleActiveCategory() {
    const allCategories = document.querySelectorAll(
      '.all-results-category-container'
    );
    allCategories.forEach(category => {
      category.classList.remove('active');
      if (
        category.innerText.includes(
          this.categories[this.pickedCategory].prettyName
        )
      ) {
        category.classList.add('active');
      }
    });
  }

  _handleEnterAndEscapeKeys() {
    const searchThis = this;
    document.body.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        searchThis._closeSearchDropdown();
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        searchThis._closeSearchDropdown();
        $('.show-all-results-container').click();
      }
    });
  }

  _openSearchDropdown() {
    const $siteHeader = $('.site-header-search input');
    const $searchDropdown = this.isSideSearch
      ? $('.sidebar-search-dropdown')
      : $('.search-dropdown');
    if (this.isSideSearch) {
      const $sidebar = $('.nav-site-sidebar');
      $sidebar.css('display', 'none');
    }
    document.body.style.overflow = 'hidden';
    $siteHeader[0].style.boxShadow = '0 0 0 9999px rgba(0, 0, 0, 0.5)';
    if (this.isSideSearch) {
      $('.site-sidebar')[0].classList.add('full');
    }
    $searchDropdown.show();
  }

  _closeSearchDropdown() {
    const $siteHeader = $('.site-header-search input');
    const $searchDropdown = $('.search-dropdown , .sidebar-search-dropdown');
    const $sidebar = $('.nav-site-sidebar');
    $siteHeader[0].style.boxShadow = 'none';
    document.body.style.overflow = 'visible';
    $sidebar.css('display', 'block');
    if (this.isSideSearch) {
      $('.site-sidebar')[0].classList.remove('full');
    }
    $searchDropdown.hide();
  }

  _allResultModalHeader() {
    const $allResultsModalHeader = $('.all-results-category');
    const searchThis = this;
    Object.keys(this.categories).map(category => {
      const categoryContainer = document.createElement('div');
      const categoryText = document.createElement('span');
      categoryText.innerText = this.categories[category].prettyName;
      const categoryLength = document.createElement('div');
      categoryLength.className = 'category-length';
      categoryLength.innerText = this.categorizedResults[category].length;
      categoryContainer.className = 'all-results-category-container';
      categoryContainer.append(categoryText, categoryLength);
      if (this.categorizedResults[category].length <= 0) {
        categoryContainer.classList.add('disabled');
      }
      categoryContainer.addEventListener('click', function(event) {
        event.preventDefault();
        searchThis.pickedCategory = category;
        searchThis.currentPage = 1;
        searchThis.isSideSearch
          ? searchThis._allResultModalDisplayInfiniteScroll()
          : searchThis._allResultModalDisplayPagination();
      });
      $allResultsModalHeader.append(categoryContainer);
    });
  }

  _clearAllContainers() {
    $('.search-results-all').empty();
    $('.pagination-container').empty();
    $('.pagination-numbers').empty();
    $('.all-results-category').empty();
  }

  _sideSearchDropdownDisplay(length, nbHits) {
    const $searchResults = $('.search-results');
    $searchResults.append(
      `<span class="search-results-headline">RESULTS</span>`
    );
    document.addEventListener('gesturestart', function(e) {
      e.preventDefault();
    });
    for (const category in this.categorizedResults) {
      if (this.categorizedResults[category].length > 0 && category !== 'ALL') {
        this._assignIconToHit(category);
        $searchResults.append(
          `<div class="category-container"><li class="category">${this.categories[category].prettyName}</li></div>`
        );
        this.categorizedResults[category].forEach((hit, index) => {
          if (index >= 2) return;
          this._appendResult($searchResults, hit);
        });
      }
    }
    $searchResults.append(
      `<div class="show-all-results-container">
           <a> See all ${Math.min(length, nbHits)} results</a>
      </div>`
    );
  }
  _mainSearchDropdownDisplay(length, nbHits) {
    const $searchResults = $('.search-results');
    $searchResults.append(
      `<span class="search-results-headline">RESULTS</span>`
    );
    for (const category in this.categorizedResults) {
      if (this.categorizedResults[category].length > 0 && category !== 'ALL') {
        this._assignIconToHit(category);
        $searchResults.append(
          `<div class="category-container"><li class="category">${this.categories[category].prettyName}</li></div>`
        );
        this.categorizedResults[category].forEach((hit, index) => {
          if (index >= 2) return;
          this._appendResult($searchResults, hit);
        });
      }
    }
    $searchResults.append(
      `<div class="show-all-results-container">
           <a> See all ${Math.min(length, nbHits)} results</a>
      </div>`
    );
  }

  _searchDropdownDisplay() {
    const $searchResults = $('.search-results');
    const $searchBars = $(
      '.site-header-search #search-bar, .site-sidebar-search #side-search-bar'
    );
    const $searchDropdown = $('.search-dropdown');
    const searchThis = this;
    this._handleEnterAndEscapeKeys();
    this._emptySearchBarOnClick();
    $searchBars.on('focus', async function(event) {
      searchThis.isSideSearch = [
        ...event.currentTarget.form.classList
      ].includes('site-sidebar-search');
      const popularSearchResults = await searchThis.QuerySuggestionindex.search(
        '',
        {
          hitsPerPage: 5
        }
      );
      if (!$(this)[0].value.toString())
        searchThis._openRecentAndPopularSearchesModal(
          popularSearchResults.hits || []
        );
      else searchThis._openSearchDropdown();
    });
    $searchBars.on('input', function() {
      searchThis.currentPage = 1;
      searchThis.query = $(this)[0].value.toString();
      searchThis.algoliaIndex
        .search(searchThis.query, {
          offset: 0,
          length: 1000
        })
        .then(({ hits, nbHits, length }) => {
          if (searchThis.query.length > 0 && hits.length) {
            searchThis._sortHits(hits);
            searchThis._initPickedCategory();
            $searchResults.empty();
            searchThis._openSearchDropdown();
            if (searchThis.isSideSearch) {
              searchThis._sideSearchDropdownDisplay(length, nbHits);
            } else {
              searchThis._mainSearchDropdownDisplay(length, nbHits);
            }
          } else if (nbHits === 0) {
            $searchResults.empty();
            $searchResults.append(
              `<div class="search-results-empty-container"><div class="search-results-empty"></div><span class="no-result-query"></span></div>`
            );
            $('.no-result-query').text(
              `No results found for "${searchThis.query.toString()}".`
            );
            searchThis._openSearchDropdown();
            return;
          } else {
            searchThis._closeSearchDropdown();
          }
          $('.show-all-results-container').on('click', function(event) {
            event.stopPropagation();
            searchThis._closeSearchDropdown();
            searchThis.isSideSearch
              ? searchThis._allResultModalDisplayInfiniteScroll()
              : searchThis._allResultModalDisplayPagination();
          });
        });
    });
    $(document).on('click', function(event) {
      if (
        !$(event.target).closest($searchDropdown).length &&
        !$(event.target).closest($searchBars).length
      ) {
        searchThis._closeSearchDropdown();
      }
      if ($(event.target).closest('.search-result-container').length) {
        const clickedContainer = $(event.target).closest(
          '.search-result-container'
        )[0];
        const url = clickedContainer.href;
        if (location.href === url) {
          event.preventDefault();
          searchThis._closeSearchDropdown();
        }
        const icon = clickedContainer.querySelector('.search-result-icon')
          .classList;
        const title = clickedContainer.querySelector('.search-result-title')
          .innerText;
        const breadcrumbs = clickedContainer.querySelector(
          '.search-result-breadcrumbs'
        ).innerHTML;
        searchThis._closeAllResultsModal();
        $searchDropdown.hide();
        searchThis._addResultsToRecentSearches({
          url,
          icon,
          title,
          breadcrumbs
        });
      }
      if ($(event.target).closest('.search-result-data.popular').length) {
        const clickedContainer = $(event.target).closest(
          '.search-result-data.popular'
        )[0];
        const query = clickedContainer.innerText;
        const $searchBar = searchThis.isSideSearch
          ? $('.site-sidebar-search #side-search-bar')
          : $('.site-header-search #search-bar');
        $searchBar[0].value = query;
        $searchBar.trigger('input');
      }
    });
  }

  _closeAllResultsModal() {
    const $allResultsModal = $('.all-results-modal');
    const $searchInput = this.isSideSearch
      ? $('#side-search-bar')
      : $('#search-bar');
    $allResultsModal.css('display', 'none');
    $searchInput[0].value = '';
    document.body.style.overflow = 'visible';
  }

  _openAllResultsModal() {
    const $allResultsModal = $('.all-results-modal');
    $allResultsModal.css('display', 'flex');
    document.body.style.overflow = 'hidden';
  }

  _emptySearchBarOnClick() {
    const $searchBarDelete = $('.icon-delete');
    const $searchBarInput = $('.search-input-container input');
    const $sideSearchBarInput = $('#side-search-bar');
    const searchThis = this;
    $searchBarDelete.on('click', function() {
      searchThis.query = '';
      searchThis.isSideSearch
        ? $sideSearchBarInput.val('')
        : $searchBarInput.val('');
    });
  }

  _allResultModalDisplayPagination() {
    const $exitModal = $('.exit-results-modal');
    const searchThis = this;
    this._clearAllContainers();
    this._openAllResultsModal();
    this._allResultModalHeader();
    this._displayAllResultPagination();
    $exitModal.on('click', function() {
      searchThis._closeAllResultsModal();
    });
    document.body.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        searchThis._closeAllResultsModal();
      }
    });
  }

  _closeModalOnHamburgerClick() {
    const $hamburger = $('.navbar-toggle');
    const $modal = $('.all-results-modal');
    const searchThis = this;
    const isOpenModal = $modal.css('display') !== 'none';
    if (isOpenModal)
      $hamburger.on('click', function() {
        searchThis._closeAllResultsModal();
      });
  }

  _allResultModalDisplayInfiniteScroll() {
    const $exitModal = $('.exit-results-modal');
    const searchThis = this;
    $('.pagination-container').css('display', 'none');
    this._clearAllContainers();
    this._openAllResultsModal();
    this._allResultModalHeader();
    this._closeModalOnHamburgerClick();
    this._displayAllResultInfiniteScroll();
    $exitModal.on('click', function() {
      searchThis._closeAllResultsModal();
    });
  }

  _preventZoomOninputClick() {
    const metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    metaTag.content =
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0';
    document.getElementsByTagName('head')[0].appendChild(metaTag);
  }

  _initAlgoliaSearch() {
    this.categories = {
      ALL: { prettyName: 'All', name: 'all' },
      REF: { prettyName: 'API Reference', name: 'api-ref' },
      GUIDE: { prettyName: 'Guides', name: 'guide' },
      CP: { prettyName: 'Client Portal', name: 'cp' }
    };
    this._preventZoomOninputClick();
    this.currentPage = 1;
    this.pickedCategory = Object.keys(this.categories)[0];
    this._searchDropdownDisplay();
    document.addEventListener('click', function() {
      const $allResultsModal = $('.all-results-modal');
      $allResultsModal.css('display') === 'flex'
        ? (document.body.style.overflow = 'hidden')
        : (document.body.style.overflow = 'visible');
    });
  }
}
